import React, { useState } from "react";
import { Helmet } from "react-helmet";
import { FormattedMessage, useIntl } from "react-intl";
import { Grid, PageWrapper } from "components/Containers";
import PageTitle from "components/PageTitle";
import Card from "components/Card";
import { PrimaryButton, SecondaryButton } from "components/Buttons";
import { Row } from "components/Containers";
import {
  BlueprintEditModal,
  BlueprintGenerateModal,
  BlueprintGenerationTasksProvider,
  BlueprintsList,
} from "components/Blueprints";
import { GET_MISSION_ROLE_TEMPLATES } from "graphql/queries";

/**
 * Blueprint Settings
 */
const BlueprintSettings = () => {
  const intl = useIntl();
  const [showCreateForm, setShowCreateForm] = useState(false);
  const [showGenerateForm, setShowGenerateForm] = useState(false);

  return (
    <PageWrapper>
      <Helmet>
        <title>{intl.formatMessage({ id: "Meta.Settings.Blueprints.Title" })}</title>
      </Helmet>
      <BlueprintGenerationTasksProvider
        query={GET_MISSION_ROLE_TEMPLATES}
        getTemplates={(data) => data?.missionRoleTemplates?.nodes}
      >
        <Grid>
          <Grid.col start={1} end={13}>
            <PageTitle
              subtitle={<FormattedMessage id="Settings.Blueprints.Title" />}
              actionBar={
                <Row>
                  <SecondaryButton onClick={() => setShowGenerateForm(true)}>
                    <FormattedMessage id="Settings.Blueprints.Generate" />
                  </SecondaryButton>
                  <PrimaryButton onClick={() => setShowCreateForm(true)}>
                    <FormattedMessage id="Settings.Blueprints.Create" />
                  </PrimaryButton>
                </Row>
              }
            />
          </Grid.col>
          <Grid.col start={1} end={13}>
            <Card>
              <BlueprintsList />
            </Card>
          </Grid.col>
        </Grid>
      </BlueprintGenerationTasksProvider>
      <BlueprintEditModal
        show={showCreateForm}
        onClose={() => setShowCreateForm(false)}
        refetchQueries={[GET_MISSION_ROLE_TEMPLATES]}
      />
      <BlueprintGenerateModal show={showGenerateForm} onClose={() => setShowGenerateForm(false)} />
    </PageWrapper>
  );
};

export default BlueprintSettings;
